import Form from 'antd/lib/form/Form'
import styled from 'styled-components'

export const CustomForm = styled(Form)`
    border-radius: 5px;
    transition: 0.3s;
    position: relative;
    width: 100%;
    background: white;
    border-bottom: 1px solid lightgrey;
    .Userdetail-btn button {
        background-color: white !important;
        border-top-style: hidden !important;
        border-right-style: hidden !important;
        border-left-style: hidden !important;
        border-bottom-style: ridge !important;
        border-color: #dbdbdb !important;
        color: #49a04d !important;
        font-weight: bold !important;
        box-shadow: 0px 2px 4px rgba(97, 97, 97, 0.18),
            0px 4px 8px rgba(97, 97, 97, 0.18);
        border-radius: 26px;
    }
    .ant-form-item-label > label {
        font-size: 12px !important;
    }
    .ant-input-suffix {
        display: none !important;
    }
    .form-item-margin {
        margin-bottom: 10px !important;
    }
`

export const Input = styled.input`
    width: 100%;
    border-radius: 5px;
    border: 2px solid #6dcf72 !important;
`

export const CustomInput = styled(Input)`
    &:focus {
        outline: none;
    }
`

export const Title = styled.p`
    font-style: normal;
    font-weight: 600;
    font-size: 34px;
    line-height: 130%;
`

export {}
